module.exports = __webpack_public_path__ + "static/media/rev2.1434bfc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-5/rev2.png
// module id = 725
// module chunks = 0